<template>
  <form id="sidebarDates" class="form-layout form-layout-2 form-dates-sidebar">
    
    <div class="row no-gutters">
      <div class="col-md-12">

        <label class="section-title mg-t-0"> <i class="fa fa-clock"></i> Transit Time </label>

        <div class="row no-gutters transit-time">
          <div class="form-group transit-time-calc col-md-4 mg-md-t--1 bd-t-1-force bd-t-1 bd-r-0-force">
            <label class="form-control-label"> Cálculo </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before mt-1">
                  <toggle-button v-model="transitTimeManual" @input="changeTransitTimeResponsability()" name="transitTimeManual" :sync="true" :labels="{checked: 'MANUAL', unchecked: 'AUTOMÁTICO'}" :color="{unchecked: '#bf0909'}" :height="16" :width="90"/>
                </div>
            </div>
          </div>

          <div class="form-group transit-time-hired col-md-4 mg-md-t--1 bd-t-1-force bd-t-1 bd-r-0-force" :class="{'bg-gray-100': !transitTimeManual, 'no-click-not-allowed': !transitTimeManual}" >
            <label class="form-control-label"> Contratado </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before form-input-transit-time" style="width: 100%" >
                <div class="flex" v-if="transitTimeManual" style="width: 100%" > 
                  <div class="flex" v-if="transitTimeActive" >
                    <input type="number" v-model="transitTime" ref="transitTimeInput" name="transitTime" @blur="transitTimeShow(true)" min="0" class="form-control form-input-transit-time input-transit-time">
                    <span class="ml-1"> {{ formatDayPlural(transitTime) }} </span>
                  </div>
                  <div style="width: 100%" v-else @click.prevent="transitTimeShow">
                    <span style="width: 100%"> {{ transitTime ?? 0 }} {{ formatDayPlural(transitTime) }} </span>
                  </div>
                </div>
                <div class="flex" v-else>
                  <span>{{ transitTimeContratado ? transitTimeContratado + formatDayPlural(transitTimeContratado) : ' - ' }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group transit-time-current col-md-4 mg-md-t--1 bd-t-1-force bd-t-1 bg-gray-100">
            <label class="form-control-label"> Atual </label>
            <div class="input-group-solved-before form-input-transit-time">
              <span> {{  transitTimeAtual && transitTimeAtual !== ' - ' ? transitTimeAtual + formatDayPlural(transitTimeAtual) : transitTimeAtual }} </span>
            </div>
          </div>
        </div>
  
        <hr>

        <label class="section-title mg-t-20"> <i class="fa fa-calendar-times-o"></i> Datas Previstas</label>
		<div class="row no-gutters">
			<div class="form-group col-md-12 mg-md-t--1">
            <label class="form-control-label"> Expectativa de Recebimento do Cliente </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before">
                <i class="fa fa-calendar op-5"></i>
              </div>
              <div class="input-group-solved-center">
                <date-picker v-model="customerExpectedReceiptDate" name="customerExpectedReceiptDate" inputName="customerExpectedReceiptDate" @change="checkCustomerExpectedReceiptDate" class="form-control" format="DD/MM/YY" lang="pt-br" placeholder="Selecione"></date-picker>
              </div>
            </div>
          </div>
		</div>
        <div class="row no-gutters">
			<div class="form-group col-md-6 mg-md-t--1 bd-t-1-force bd-t-1">
				<label class="form-control-label"> Prontidão </label>
				<div class="input-group-solved">
					<div class="input-group-solved-before">
						<i class="fa fa-calendar op-5"></i>
					</div>
					<div class="input-group-solved-center">
						<date-picker 
							v-model="datesEstimatedGoodsReadinesDate" 
							name="datesEstimatedGoodsReadinesDate"	
							inputName="datesEstimatedGoodsReadinesDate" 
							class="form-control" 
							format="DD/MM/YY"
							lang="pt-br" 
							placeholder="Selecione"
							@change="checkDatesEstimatedGoodsReadinesDate"
						></date-picker>
					</div>
				</div>
			</div>
			<div class="form-group col-md-6 mg-md-t--1 bd-l-0-force bd-t-1">
				<label class="form-control-label">Coleta</label>
				<div class="input-group-solved">
					<div class="input-group-solved-before">
						<i class="fa fa-calendar op-5"></i>
					</div>
					<div class="input-group-solved-center">
						<date-picker
						lang="pt-br"
						v-model="datesEstimatedCargoCollectDate"
						v-validate="'required'"
						class="form-control"
						format="DD/MM/YY"
						inputName="datesEstimatedCargoCollectDate"
						name="datesEstimatedCargoCollectDate"
						placeholder="Selecione"
						></date-picker>
					</div>
				</div>
			</div>

			<div class="form-group col-md-6 mg-md-t--1" :class="initialDatesETD != null ? 'bg-gray-200' : ''">
				<label class="form-control-label"> ETD Inicial </label>
				<div class="input-group-solved">
				<div class="input-group-solved-before">
					<i class="fa fa-calendar op-5"></i>
				</div>
				<div class="input-group-solved-center">
					<date-picker v-model="initialDatesETD" @change="changeInitialDatesETD" name="initialDatesETD"
								inputName="initialDatesETD" class="form-control" format="DD/MM/YY" lang="pt-br"
								placeholder="Selecione"></date-picker>
				</div>
				</div>
			</div>	
			<div class="form-group col-md-6 mg-md-t--1 bd-l-0-force">
				<label class="form-control-label"> ETD </label>
				<div class="input-group-solved">
				<div class="input-group-solved-before">
					<i class="fa fa-calendar op-5"></i>
				</div>
				<div class="input-group-solved-center">
					<date-picker 
						v-model="datesETD" 
						name="datesETD" 
						inputName="datesETD" 
						class="form-control"
						format="DD/MM/YY" 
						lang="pt-br" 
						placeholder="Selecione"
						@input="checkDatesETD"
					>
					</date-picker>
				</div>
				</div>
			</div>
        </div>

        <div class="row no-gutters">
          <div class="form-group col-md-6 mg-md-t--1  bd-t-0-force bd-b-0-force">
            <label class="form-control-label"> ETA </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before">
                <i class="fa fa-calendar op-5"></i>
              </div>
              <div class="input-group-solved-center">
                <date-picker v-model="datesETA" name="datesETA" @change="checkDatesETA" inputName="datesETA" class="form-control"
                             format="DD/MM/YY" lang="pt-br" placeholder="Selecione"></date-picker>
              </div>
            </div>
          </div>

          <div class="form-group col-md-6 mg-md-t--1 bd-l-0-force bd-t-0-force bd-b-0-force">
            <label class="form-control-label"> Entrega Cliente </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before">
                <i class="fa fa-calendar op-5"></i>
              </div>
              <div class="input-group-solved-center">
                <date-picker v-model="datesEstimatedCustomerDeliverDate" name="datesEstimatedCustomerDeliverDate"
                             inputName="datesEstimatedCustomerDeliverDate" class="form-control" format="DD/MM/YY"
                             lang="pt-br" placeholder="Selecione"></date-picker>
              </div>
            </div>
          </div>
        
          <div class="form-group col-md-6 mg-md-t--1">
            <label class="form-control-label">Numerário</label>
            <div class="input-group-solved">
              <div class="input-group-solved-before">
                <i class="fa fa-calendar op-5"></i>
              </div>
              <div class="input-group-solved-center">
                <date-picker
                  lang="pt-br"
                  v-model="estimatedStepCashRequest"
                  v-validate="'required'"
                  class="form-control"
                  format="DD/MM/YY"
                  inputName="estimatedStepCashRequest"
                  name="estimatedStepCashRequest"
                  placeholder="Selecione"
                ></date-picker>
              </div>
            </div>
            <span v-if="!datesETA" class="badge badge-danger tx-normal sidebar-ta-hint mg-t-5">
              Preencher quando não houver o ETA
            </span>
        
          </div>
          <div class="form-group col-md-6 mg-md-t--1 bd-l-0-force bg-gray-100">
            <label class="form-control-label">Previsão Invoice</label>
            <div class="input-group-solved">
              <div class="input-group-solved-before">
                <i class="fa fa-calendar op-5"></i>
              </div>
              <div class="input-group-solved-center">
                <date-picker
                  lang="pt-br"
                  v-model="estimatedInvoiceDate"
                  v-validate="'required'"
                  class="form-control"
                  format="DD/MM/YY"
                  inputName="estimatedInvoiceDate"
                  name="estimatedInvoiceDate"
                  placeholder="Selecione"
                  disabled
                ></date-picker>
              </div>
            </div>       
          </div>

        </div>

        <hr>

        <label class="section-title mg-t-20"> <i class="fa fa-calendar-check-o"></i> Datas Confirmadas</label>

        <div class="row no-gutters">
          <div class="form-group col-md-6 mg-md-t--1 bd-t-1">
            <label class="form-control-label"> Prontidão </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before">
                <i class="fa fa-calendar op-5"></i>
              </div>
              <div class="input-group-solved-center">
                <date-picker v-model="datesGoodsReadinesDate" name="datesGoodsReadinesDate"
                             inputName="datesGoodsReadinesDate" class="form-control" format="DD/MM/YY" lang="pt-br"
                             placeholder="Selecione"></date-picker>
              </div>
            </div>
          </div>
			<div class="form-group col-md-6 mg-md-t--1 bd-t-1 bd-l-0-force">
				<label class="form-control-label"> Coleta </label>
				<div class="input-group-solved">
					<div class="input-group-solved-before">
						<i class="fa fa-calendar op-5"></i>
					</div>
					<div class="input-group-solved-center">
						<date-picker 
							v-model="datesCargoCollectDate" 
							name="datesCargoCollectDate"
							inputName="datesCargoCollectDate" 
							class="form-control" 
							format="DD/MM/YY" 
							lang="pt-br"
							v-validate="'required'" 
							placeholder="Selecione">
						</date-picker>
					</div>
				</div>
			</div>

          <div class="form-group col-md-6 mg-md-t--1">
            <label class="form-control-label"> Embarque </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before">
                <i class="fa fa-calendar op-5"></i>
              </div>
              <div class="input-group-solved-center">
                <date-picker
                  v-model="datesDepartureDate"
                  name="datesDepartureDate"
                  inputName="datesDepartureDate"
                  class="form-control" format="DD/MM/YY" lang="pt-br" v-validate="'required'"
                  placeholder="Selecione"
				  @input="checkDatesDepartureDate"
                ></date-picker>
              </div>
            </div>
          </div>

          <div class="form-group col-md-6 mg-md-t--1 bd-t-1 bd-l-0-force" :class="!process.administrativeTreatmentDone ? 'height-none' : ''">
            <label class="form-control-label"> Atracação </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before">
                <i class="fa fa-calendar op-5"></i>
              </div>
              <div class="input-group-solved-center">
                <date-picker v-model="mooringDate" name="mooringDate" inputName="mooringDate" class="form-control"
                             format="DD/MM/YY" lang="pt-br" placeholder="Selecione"></date-picker>
              </div>
            </div>
          </div>

          <div class="form-group col-md-6 mg-md-t--1">
            <label class="form-control-label"> Chegada </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before">
                <i class="fa fa-calendar op-5"></i>
              </div>
              <div class="input-group-solved-center">
                <date-picker v-model="datesArrivalDate" name="datesArrivalDate" inputName="datesArrivalDate"
                             class="form-control" format="DD/MM/YY" lang="pt-br" v-validate="'required'"
                             placeholder="Selecione" @change="checkDatesArrivalDate"></date-picker>
              </div>
            </div>
          </div>

          <div class="form-group col-md-6 mg-md-t--1 bd-t-1 bd-l-0-force">
            <label class="form-control-label"> Presença </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before">
                <i class="fa fa-calendar op-5"></i>
              </div>
              <div class="input-group-solved-center">
                <date-picker v-model="datesGoodsPresenceDate" name="datesGoodsPresenceDate"
                             inputName="datesGoodsPresenceDate" class="form-control" format="DD/MM/YY" lang="pt-br"
                             v-validate="'required'" placeholder="Selecione"></date-picker>
              </div>
            </div>
          </div>

          <div class="form-group col-md-6 mg-md-t--1" v-if="!process.duimp">
            <label class="form-control-label"> Vistoria da DI </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before">
                <i class="fa fa-calendar op-5"></i>
              </div>
              <div class="input-group-solved-center">
                <date-picker v-model="datesInspectionOfTheDIDate" name="datesInspectionOfTheDIDate"
                             inputName="datesInspectionOfTheDIDate" class="form-control" format="DD/MM/YY" lang="pt-br"
                             v-validate="'required'" placeholder="Selecione"></date-picker>
              </div>
            </div>
          </div>

          <div class="form-group col-md-6 mg-md-t--1" v-else>
            <label class="form-control-label"> Vistoria da DUIMP </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before">
                <i class="fa fa-calendar op-5"></i>
              </div>
              <div class="input-group-solved-center">
                <date-picker v-model="datesInspectionOfTheDuimpDate" name="datesInspectionOfTheDuimpDate"
                             inputName="datesInspectionOfTheDuimpDate" class="form-control" format="DD/MM/YY" lang="pt-br"
                             v-validate="'required'" placeholder="Selecione"></date-picker>
              </div>
            </div>
          </div>

          <div class="form-group col-md-6 mg-md-t--1 bd-t-1 bd-l-0-force">
            <label class="form-control-label"> Carregamento </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before">
                <i class="fa fa-calendar op-5"></i>
              </div>
              <div class="input-group-solved-center">
                <date-picker v-model="datesGoodsLoadingDate" name="datesGoodsLoadingDate"
                             inputName="datesGoodsLoadingDate" class="form-control" format="DD/MM/YY" lang="pt-br"
                             v-validate="'required'" placeholder="Selecione"></date-picker>
              </div>
            </div>
          </div>
        
          <div class="form-group col-md-6 mg-md-t--1">
            <label class="form-control-label"> Entrega Cliente </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before">
                <i class="fa fa-calendar op-5"></i>
              </div>
              <div class="input-group-solved-center">
                <date-picker v-model="datesCustomerDeliverDate" name="datesCustomerDeliverDate"
                             inputName="datesCustomerDeliverDate" class="form-control" format="DD/MM/YY" lang="pt-br"
                             v-validate="'required'" placeholder="Selecione"></date-picker>
              </div>
            </div>
          </div>
        </div>

        <hr>
        <label class="section-title mg-t-20"><i class="fa fa-tree"></i> MAPA</label>

        <div class="row no-gutters">
          <div class="form-group col-md-6 mg-md-t--1 col-md-6 ">
            <label class="form-control-label"> Vistoria MAPA </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before">
                <i class="fa fa-calendar op-5"></i>
              </div>
              <div class="input-group-solved-center">
                <date-picker v-model="datesInspectionMAPADate" name="datesInspectionMAPADate"
                             inputName="datesInspectionMAPADate" class="form-control" format="DD/MM/YY" lang="pt-br"
                             v-validate="'required'" placeholder="Selecione"></date-picker>
              </div>
              <div class="input-group-solved-after"><label class="ckbox wd-16 mg-b-0"> <input
                v-model="datesInspectionMAPADateSolved" type="checkbox"
                name="datesInspectionMAPADateSolved"><span></span> </label></div>
            </div>
          </div>
          <div class="form-group col-md-6 mg-md-t--1 bd-l-0-force">
            <label class="form-control-label"> Liberação MAPA </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before">
                <i class="fa fa-calendar op-5"></i>
              </div>
              <div class="input-group-solved-center">
                <date-picker v-model="datesReleaseMAPADate" name="datesReleaseMAPADate" inputName="datesReleaseMAPADate"
                             class="form-control" format="DD/MM/YY" lang="pt-br" v-validate="'required'"
                             placeholder="Selecione"></date-picker>
              </div>
              <div class="input-group-solved-after"><label class="ckbox wd-16 mg-b-0"> <input
                v-model="datesReleaseMAPADateSolved" type="checkbox" name="datesReleaseMAPADateSolved"><span></span>
              </label></div>
            </div>
          </div>

          <div class="form-group col-md-12 mg-md-t--1 col-md-6 bd-t-0-force">
            <label class="form-control-label"> Vínculo no Recinto </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before">
                <i class="fa fa-calendar op-5"></i>
              </div>
              <div class="input-group-solved-center">
                <date-picker v-model="datesLinkInTheEnclosureDate" name="datesLinkInTheEnclosureDate"
                             inputName="datesLinkInTheEnclosureDate" class="form-control" format="DD/MM/YY" lang="pt-br"
                             v-validate="'required'" placeholder="Selecione"></date-picker>
              </div>
              <div class="input-group-solved-after"><label class="ckbox wd-16 mg-b-0"> <input
                v-model="datesLinkInTheEnclosureDateSolved" type="checkbox"
                name="datesLinkInTheEnclosureDateSolved"><span></span> </label></div>
            </div>
          </div>
        </div>

        <hr>
        <label class="section-title mg-t-20"> <i class="fa fa-newspaper-o"></i> Conhecimento</label>

        <div class="row no-gutters">

          <div class="form-group col-md-6">
            <label class="form-control-label"> Siscarga</label>
            <div class="input-group-solved">
              <div class="input-group-solved-before mg-t-3">
                <i class="fa fa-calendar op-5"></i>
              </div>
              <div class="input-group-solved-center">
                <date-picker v-model="datesSiscargaDate" name="datesSiscargaDate" inputName="datesSiscargaDate"
                             class="form-control" format="DD/MM/YY" lang="pt-br" v-validate="'required'"
                             placeholder="Selecione"></date-picker>
              </div>
            </div>
          </div>

          <div class="form-group col-md-6 bd-l-0-force">
            <label class="form-control-label"> Liberação AWB/BL </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before mg-t-3">
                <i class="fa fa-calendar op-5"></i>
              </div>
              <div class="input-group-solved-center">
                <date-picker v-model="datesBillOfLadingReleaseDate" name="datesBillOfLadingReleaseDate"
                             inputName="datesBillOfLadingReleaseDate" class="form-control" format="DD/MM/YY"
                             lang="pt-br" v-validate="'required'" placeholder="Selecione"></date-picker>
              </div>
            </div>
          </div>

          <div class="form-group col-md-12 mg-md-t--1 col-md-6 bd-t-0-force">
            <label class="form-control-label">Termo de falta de Avaria</label>
            <div class="input-group-solved">
              <div class="input-group-solved-before mg-r-5 mg-t-3">
                <toggle-button v-model="datesTFASolved" name="datesTFASolved" :sync="true"
                               :labels="{checked: ' LIBERADO ', unchecked: ' PENDENTE '}"
                               :color="{unchecked: '#bf0909'}" :height="16" :width="80"/>
              </div>
              <div class="input-group-solved-after"></div>
            </div>
          </div>
        </div>

        <hr>

        <label class="section-title mg-t-20"> <i class="fa fa-truck"></i> Transferência de Carga</label>

        <div class="row no-gutters">
          <div class="form-group col-md-6">
            <label class="form-control-label"> DTC / DTA </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before mg-r-5 mg-t-1">
                <toggle-button v-model="datesIsThereDTCDTATransfer" name="datesIsThereDTCDTATransfer" :sync="true"
                               :labels="{checked: 'SIM', unchecked: 'NÃO'}" :color="{unchecked: '#bf0909'}" :height="16"
                               :width="50"/>
              </div>
              <div class="input-group-solved-after">
                <date-picker v-model="datesDTCDTA" name="datesDTCDTA" inputName="datesDTCDTA" class="form-control"
                             format="DD/MM/YY" lang="pt-br" v-validate="'required'"
                             placeholder="Selecione"></date-picker>
              </div>
            </div>
          </div>

          <div class="form-group col-md-6 bd-l-0-force">
            <label class="form-control-label"> Desova </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before mg-r-5 mg-t-1">
                <toggle-button v-model="datesThereIsDesova" name="datesThereIsDesova" :sync="true"
                               :labels="{checked: 'SIM', unchecked: 'NÃO'}" :color="{unchecked: '#bf0909'}" :height="16"
                               :width="50"/>
              </div>
              <div class="input-group-solved-after">
                <date-picker v-model="datesDesova" name="datesDesova" inputName="datesDesova" class="form-control"
                             format="DD/MM/YY" lang="pt-br" v-validate="'required'"
                             placeholder="Selecione"></date-picker>
              </div>
            </div>
          </div>

          <div class="form-group col-md-6 bd-t-0-force">
            <label class="form-control-label"> Fat Recinto </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before ">
                <i class="fa fa-calendar op-5"></i>
              </div>
              <div class="input-group-solved-center">
                <date-picker v-model="datesEnclosureBillingDate" name="datesEnclosureBillingDate"
                             inputName="datesEnclosureBillingDate" class="form-control" format="DD/MM/YY" lang="pt-br"
                             v-validate="'required'" placeholder="Selecione"></date-picker>
              </div>
            </div>
          </div>

          <div class="form-group col-md-6 bd-t-0-force bd-l-0-force">
            <label class="form-control-label"> Comex </label>
            <div class="input-group-solved">
              <div class="input-group-solved-before">
                <i class="fa fa-calendar op-5"></i>
              </div>
              <div class="input-group-solved-center">
                <date-picker v-model="datesComexDate" name="datesComexDate" inputName="datesComexDate"
                             class="form-control" format="DD/MM/YY" lang="pt-br" v-validate="'required'"
                             placeholder="Selecione"></date-picker>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row no-gutters">
        <div class="col-md-12">
          <hr>
          <div v-if="legacyId !== null">
            <label class="section-title mg-t-20"><i class="fa fa-calendar-times-o"></i> Abertura </label>
            {{ legacyCreated | moment("DD/MM/YYYY \\à\\s HH:mm:ss") }} por {{ legacyCreatedBy }}
          </div>
          <div v-else>
            <label class="section-title mg-t-20">
              <i class="fa fa-calendar-times-o"></i>
              Abertura
            </label>
            {{ created | moment("DD/MM/YYYY \\à\\s HH:mm:ss") }} por {{ createdBy }}
          </div>
          <hr>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import Axios from "axios";
import config from "@/config.js";
import { mapState, mapActions } from "vuex";
import DatePicker from "vue2-datepicker";
import ToggleButton from "vue-js-toggle-button/src/Button.vue";
import Swal from "sweetalert2";
import moment from "moment";
import {EventBus} from "@/events/EventBus.js";

export default {
  components: {
    DatePicker,
    ToggleButton,
  },
  name: "FormSidebarDates",
  data() {
    return {
      modalDatesEstimatedGoodsReadinesDate: false,
      modalData: {
        value: null,
        options: [
          {
            label: "Aéreo -  Europa / USA + 7 dias",
            value: 7,
          },
          {
            label: "Aéreo - Asia + 15 dias",
            value: 15,
          },
          {
            label: "Marítimo Europa / USA + 30 dias",
            value: 30,
          },
          {
            label: "Marítimo - Asia  + 60 dias",
            value: 60,
          },
        ],
      },
      initialDatesETD: null,
      datesEstimatedGoodsReadinesDate: null,
      datesETD: null,
      datesETA: null,
      datesEstimatedCustomerDeliverDate: null,
      datesGoodsReadinesDate: null,
      datesDepartureDate: null,
      mooringDate: null,
      datesArrivalDate: null,
      datesGoodsPresenceDate: null,
      datesInspectionOfTheDIDate: null,
      datesInspectionOfTheDuimpDate: null,
      datesGoodsLoadingDate: null,
      datesCustomerDeliverDate: null,
      datesInspectionMAPADate: null,
      datesInspectionMAPADateSolved: null,
      datesReleaseMAPADate: null,
      datesReleaseMAPADateSolved: null,
      datesLinkInTheEnclosureDate: null,
      datesLinkInTheEnclosureDateSolved: null,
      datesSiscargaState: null,
      datesSiscargaDate: null,
      datesBillOfLadingReleaseDate: null,
      datesTFASolved: null,
      datesIsThereDTCDTATransfer: null,
      datesDTCDTA: null,
      datesThereIsDesova: null,
      datesDesova: null,
      datesEnclosureBillingDate: null,
      datesComexDate: null,
      legacyId: null,
      legacyCreated: null,
      legacyCreatedBy: null,
      created: null,
      createdBy: null,
      estimatedStepCashRequest: null,
      estimatedInvoiceDate: null,
	  datesCargoCollectDate: null,
	  datesEstimatedCargoCollectDate: null,
      transitTimeContratado: '',
      transitTimeAtual: ' - ',
      transitTimeManual: null,
      transitTime: null,
      transitTimeActive: false,
	  customerExpectedReceiptDate: null,
    };
  },
  methods: {
    ...mapActions("ProcessStore", ["getFreightQuotationsResponses"]),
    async calculateTransitTime() {
      this.transitTimeContratado = "";
      
      if (this.datesDepartureDate !== null && this.datesArrivalDate !== null) {
        this.transitTimeAtual = moment(this.datesArrivalDate).diff(moment(this.datesDepartureDate), 'days');
      } else if(this.datesDepartureDate !== null && this.datesETA !== null) {
        this.transitTimeAtual = moment(this.datesETA).diff(moment(this.datesDepartureDate), 'days');
      } else if(this.datesETD !== null && this.datesETA !== null) {
        this.transitTimeAtual = moment(this.datesETA).diff(moment(this.datesETD), 'days');
      } else {
        this.transitTimeAtual = ' - ';
      }

      if (this.freightQuotationsResponses.freightQuotations && this.freightQuotationsResponses.freightQuotations.length > 0) {
        const quotation = this.freightQuotationsResponses.freightQuotations.find(item => item.approved === true);

        if (quotation) {
          this.transitTimeContratado = quotation.transitTime;
        }
      }
    },
    changeTransitTimeResponsability() {
      Swal.fire({
        title: this.transitTimeManual
          ? "Transit Time Manual"
          : "Transit Time Automático",
        text: this.transitTimeManual
          ? "Ao confirmar, você precisará informar a quantidade de dias do Transit Time Contratado manualmente. Você deseja confirmar?"
          : "Ao confirmar, a quantidade de dias do Transit Time Contratado será baseado na cotação de frete aprovada. Você deseja confirmar?",
        type: "warning",
        showConfirmButton: true,
        confirmButtonText: 'Confirmar',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.value && result.value == true) {
          this.diffObjects("transitTimeManual");

          if (!this.transitTimeManual) {
            this.transitTime = 0;

            this.diffObjects("transitTime");
          }
        } else {
          this.transitTimeManual = !this.transitTimeManual;
        }
      });
    },
	async checkDatesDepartureDate() {
      this.diffObjects("datesDepartureDate");
    },
	async checkDatesETD() {
		let process = {
			...this.process,
			datesETD: this.datesETD,
		};
		await this.$store.dispatch("ProcessStore/checkAdministrativeTreatmentDoneDatesETD", { process: process});
		this.diffObjects("datesETD");
	},
    checkDatesEstimatedGoodsReadinesDate(){
      if(this.process.daysToStepCashRequestCalculation == null && this.datesEstimatedGoodsReadinesDate != null){
        EventBus.$emit("Operational.imp.form.general.changeWayOfTransport", this.process);
      }
    },
    changeInitialDatesETD() {
      if (this.initialDatesETD != null) {
        Swal.fire({
          title: "Você tem certeza que este dado esta correto?",
          html: `Deseja realmente alterar a data inicial de ETD para ${moment(
            this.initialDatesETD
          ).format("DD/MM/YYYY")}`,
          type: "warning",
          showConfirmButton: true,
          confirmButtonText: 'Confirmar',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
        }).then((result) => {
          if (result.value && result.value == true) {
            this.diffObjects("initialDatesETD");
          } else {
            if (this.initialDatesETD == null) {
              this.initialDatesETD = null;
            }
          }
        });
      }
    },
	async checkCustomerExpectedReceiptDate() {
      if (!this.customerExpectedReceiptDate ) {
		this.diffObjects("customerExpectedReceiptDate");
        return;
      }
	  await this.checkDatesETA();
	  await this.checkDatesArrivalDate();
	  this.diffObjects("customerExpectedReceiptDate");
    },
    async checkDatesETA() {
      if (!this.datesETA || this.datesArrivalDate) {
		this.diffObjects("datesETA");
        return;
      }
      await this.alertCriticalCustomerExpectedReceiptIfWithinSevenDays(this.datesETA, "datesETA");
    },
    async checkDatesArrivalDate() {
      if (!this.datesArrivalDate) {
		this.diffObjects("datesArrivalDate");
        return;
      }
      await this.alertCriticalCustomerExpectedReceiptIfWithinSevenDays( this.datesArrivalDate, "datesArrivalDate");
    },
    async alertCriticalCustomerExpectedReceiptIfWithinSevenDays(compareDate, fieldName) {
      if (!compareDate || !this.customerExpectedReceiptDate) {
		this.diffObjects(fieldName);
        return;
      }
      const ref = moment(compareDate).startOf("day");
      const expected = moment(this.customerExpectedReceiptDate).startOf("day");
      const daysDiff = Math.abs(ref.diff(expected, "days"));
      const isBeforeExpected = ref.isBefore(expected, "day");
      if (isBeforeExpected && daysDiff > 7) {
		this.diffObjects(fieldName);
        return;
      }
      const formatted = moment(this.customerExpectedReceiptDate).format("DD/MM/YYYY");
      Swal.fire({
        title: "Atenção: Prazo crítico!",
        html:
          `<p>A expectativa do cliente em receber esta mercadoria é dia <strong>${formatted}</strong>.</p>` +
          "<p>Verifique se será possível atender à expectativa do cliente ou alinhe com ele a nova data de entrega.</p>",
        type: "warning",
        confirmButtonText: "Ok",
      }).then(() => {
		this.diffObjects(fieldName);
      });
    },
    async diffObjects(fieldName) {
      const newModel = {
        ...this.process,
      };
      newModel[fieldName] = this[fieldName];

      await this.$store.dispatch("ProcessStore/diffObjects", {
        initialModel: {
          ...this.process,
        },
        model: newModel,
        fieldName: fieldName,
      });
    },

    updateAttrs(process) {
      this.datesEstimatedGoodsReadinesDate =
        process.datesEstimatedGoodsReadinesDate;
      this.datesETD = process.datesETD;
      this.initialDatesETD = process.initialDatesETD;
      this.datesETA = process.datesETA;
      this.datesEstimatedCustomerDeliverDate =
        process.datesEstimatedCustomerDeliverDate;
      this.datesGoodsReadinesDate = process.datesGoodsReadinesDate;
      this.datesDepartureDate = process.datesDepartureDate;
      this.mooringDate = process.mooringDate;
      this.datesArrivalDate = process.datesArrivalDate;
      this.datesGoodsPresenceDate = process.datesGoodsPresenceDate;
      this.datesInspectionOfTheDIDate = process.datesInspectionOfTheDIDate;
      this.datesInspectionOfTheDuimpDate = process.datesInspectionOfTheDuimpDate;
      this.datesGoodsLoadingDate = process.datesGoodsLoadingDate;
      this.datesCustomerDeliverDate = process.datesCustomerDeliverDate;
      this.datesInspectionMAPADate = process.datesInspectionMAPADate;
      this.datesInspectionMAPADateSolved =
        process.datesInspectionMAPADateSolved;
      this.datesReleaseMAPADate = process.datesReleaseMAPADate;
      this.datesReleaseMAPADateSolved = process.datesReleaseMAPADateSolved;
      this.datesLinkInTheEnclosureDate = process.datesLinkInTheEnclosureDate;
      this.datesLinkInTheEnclosureDateSolved =
        process.datesLinkInTheEnclosureDateSolved;
      this.datesSiscargaState = process.datesSiscargaState;
      this.datesSiscargaDate = process.datesSiscargaDate;
      this.datesBillOfLadingReleaseDate = process.datesBillOfLadingReleaseDate;
      this.datesTFASolved = process.datesTFASolved;
      this.datesIsThereDTCDTATransfer = process.datesIsThereDTCDTATransfer;
      this.datesDTCDTA = process.datesDTCDTA;
      this.datesThereIsDesova = process.datesThereIsDesova;
      this.datesDesova = process.datesDesova;
      this.datesEnclosureBillingDate = process.datesEnclosureBillingDate;
	  this.datesCargoCollectDate = process.datesCargoCollectDate;
	  this.datesEstimatedCargoCollectDate = process.datesEstimatedCargoCollectDate;
      this.datesComexDate = process.datesComexDate;
      this.legacyId = process.legacyId;
      this.legacyCreated = process.legacyCreated;
      this.legacyCreatedBy = process.legacyCreatedBy;
      this.created = process.created;
      this.createdBy = process.createdBy;
      this.estimatedStepCashRequest = process.estimatedStepCashRequest;
      this.estimatedInvoiceDate = process.estimatedInvoiceDate;
      this.transitTimeManual = process.transitTimeManual;
      this.transitTime = process.transitTime;
	  this.customerExpectedReceiptDate = process?.customerExpectedReceiptDate || null;
    },
    formatDayPlural(quantity){
      return quantity == "1" ? ' dia' : ' dias';
    },
    transitTimeShow(diffObjects = false) {
      if(diffObjects){
        this.diffObjects("transitTime");
      }
      this.transitTimeActive = !this.transitTimeActive;

      if (this.transitTimeActive) {
        setTimeout(() => {
          this.$refs.transitTimeInput.focus();
        }, 100);
      }
    }
  },
  computed: {
    ...mapState({
      process: (state) => state.ProcessStore.activeProcess,
      freightQuotationsResponses: (state) => state.ProcessStore.freightQuotationsResponses,
    }),
  },
  async created() {
    this.updateAttrs(this.process);
    await this.calculateTransitTime();
  },
  async mounted(){
    this.getFreightQuotationsResponses(this.process.id);
    await this.calculateTransitTime();
	this.$nextTick(() => {
      if (typeof $ !== 'undefined') {
        $('[data-toggle="tooltip"]').tooltip();
      }
    });
  },
  watch: {
    process: function (newVal, oldVal) {
      this.getFreightQuotationsResponses(newVal.id);
      this.calculateTransitTime();
      this.updateAttrs(newVal);
    },
    freightQuotationsResponses: function () {
      this.calculateTransitTime();
    },
    estimatedInvoiceDate: function () {
      this.diffObjects("estimatedInvoiceDate");
    },
    estimatedStepCashRequest: function () {
      this.diffObjects("estimatedStepCashRequest");
    },
    datesEstimatedGoodsReadinesDate: function () {
      this.diffObjects("datesEstimatedGoodsReadinesDate");
    },
    // datesETD: function () {
    //   this.diffObjects("datesETD");
    // },
    datesEstimatedCustomerDeliverDate: function () {
      this.diffObjects("datesEstimatedCustomerDeliverDate");
    },
    datesGoodsReadinesDate: function () {
      this.diffObjects("datesGoodsReadinesDate");
    },
    mooringDate: function () {
      this.diffObjects("mooringDate");
    },
    datesGoodsPresenceDate: function () {
      this.diffObjects("datesGoodsPresenceDate");
    },
    datesInspectionOfTheDIDate: function () {
      this.diffObjects("datesInspectionOfTheDIDate");
    },
    datesInspectionOfTheDuimpDate: function () {
      this.diffObjects("datesInspectionOfTheDuimpDate");
    },
    datesGoodsLoadingDate: function () {
      this.diffObjects("datesGoodsLoadingDate");
    },
    datesCustomerDeliverDate: function () {
      this.diffObjects("datesCustomerDeliverDate");
    },
    datesInspectionMAPADate: function () {
      this.diffObjects("datesInspectionMAPADate");
    },
    datesInspectionMAPADateSolved: function () {
      this.diffObjects("datesInspectionMAPADateSolved");
    },
    datesReleaseMAPADate: function () {
      this.diffObjects("datesReleaseMAPADate");
    },
    datesReleaseMAPADateSolved: function () {
      this.diffObjects("datesReleaseMAPADateSolved");
    },
    datesLinkInTheEnclosureDate: function () {
      this.diffObjects("datesLinkInTheEnclosureDate");
    },
    datesLinkInTheEnclosureDateSolved: function () {
      this.diffObjects("datesLinkInTheEnclosureDateSolved");
    },
    datesSiscargaState: function () {
      this.diffObjects("datesSiscargaState");
    },
    datesSiscargaDate: function () {
      this.diffObjects("datesSiscargaDate");
    },
    datesBillOfLadingReleaseDate: function () {
      this.diffObjects("datesBillOfLadingReleaseDate");
    },
    datesTFASolved: function () {
      this.diffObjects("datesTFASolved");
    },
    datesIsThereDTCDTATransfer: function () {
      this.diffObjects("datesIsThereDTCDTATransfer");
    },
    datesDTCDTA: function () {
      this.diffObjects("datesDTCDTA");
    },
    datesThereIsDesova: function () {
      this.diffObjects("datesThereIsDesova");
    },
    datesDesova: function () {
      this.diffObjects("datesDesova");
    },
    datesEnclosureBillingDate: function () {
      this.diffObjects("datesEnclosureBillingDate");
    },
    datesComexDate: function () {
      this.diffObjects("datesComexDate");
    },
	datesCargoCollectDate: function () {
	  this.diffObjects("datesCargoCollectDate");
	},
	datesEstimatedCargoCollectDate: function () {
	  this.diffObjects("datesEstimatedCargoCollectDate");
	},
    legacyId: function () {
      this.diffObjects("legacyId");
    },
    legacyCreated: function () {
      this.diffObjects("legacyCreated");
    },
    legacyCreatedBy: function () {
      this.diffObjects("legacyCreatedBy");
    },
    created: function () {
      this.diffObjects("created");
    },
    createdBy: function () {
      this.diffObjects("createdBy");
    },
  },
  updated() {
    this.$nextTick(() => {
      if (typeof $ !== 'undefined') {
        $('[data-toggle="tooltip"]').tooltip();
      }
    });
  },
};
</script>

<style lang="scss" scoped>
/* Bootstrap .badge usa white-space: nowrap; sem isso o fundo não acompanha o texto na coluna */
.badge.sidebar-ta-hint {
  box-sizing: border-box;
  white-space: normal;
  text-align: left;
  line-height: 1.15;
}

.height-none {
  height: auto !important;
}
.form-layout-2 .form-dates-sidebar {
  height: 100vh;

  .form-group {
    height: initial;

    & > label {
      min-width: 120px;
      margin: 0 20px 0 0;
    }
  }
}

.form-input-transit-time {
  font-family: "Lato", "Helvetica Neue", Arial, sans-serif;
  color: #343a40;
  font-weight: 700;
  font-size: 16px;
}

/* Chrome, Safari, Edge e Opera */
.input-transit-time::-webkit-inner-spin-button,
.input-transit-time::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
.input-transit-time {
  -moz-appearance: textfield;
}

.input-transit-time{
  width: 40px;
}

.transit-time {
  height: 61px;
}

@media (max-width: 1600px) {

  .transit-time {
    height: unset;
  }

  .transit-time-calc {
    flex: 0 0 100%;
    max-width: 100%;
    border: 1px solid #ced4da !important;
  }

  .transit-time-hired {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .transit-time-current {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

</style>
